import styled from '../../theme/styled-with-theme';
import { pxToRem } from '../../styles/utils';
import { mediaQueries } from '../../styles/media-queries';

import { Text } from '../Text';

export const MaxWidthHeading = styled(Text)`
  max-width: ${pxToRem(390)};
`;

export const FullWidthHeading = styled(Text)`
  text-align: left;

  ${mediaQueries.desktop} {
    text-align: center;
  }
`;
